import styled from 'styled-components';

import {
  ShowPhoneNumberButton,
  CallPhoneNumberButtonLink as BaseCallLink,
} from '../../../../../../components/Toolkit/ShowPhoneNumberButton/ShowPhoneNumberButton.styled';
import { ModalHeader } from '../../../../../../components/ToolkitV2/Modal/subcomponents/ModalHeader';

export const CallPhoneNumberButtonLink = styled(BaseCallLink)`
  display: flex;
  width: 100%;
`;

export const SModalHeader = styled(ModalHeader)`
  margin-bottom: ${({ theme }) => theme.spacing.M24};
`;

export { ShowPhoneNumberButton };
